var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ob1-tooltip" }, [
    _c(
      "button",
      {
        staticClass: "ob1-tooltip-trigger ob1-link-icon ob1-link-icon-small",
        attrs: { type: "button", "aria-describedby": _vm.id },
      },
      [
        _c("span", {
          staticClass: "icon icon-info-alt font-size-24",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ob1-link-icon-text" }, [_vm._v("DAS")]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ob1-tooltip-content ob1-tooltip-top" }, [
      _c("p", {
        staticClass: "visually-hidden",
        attrs: { id: _vm.id, role: "tooltip" },
        domProps: { innerHTML: _vm._s(_vm.accessibilityMessage) },
      }),
      _vm._v(" "),
      _vm.das.head
        ? _c("div", {
            attrs: { "aria-hidden": "true" },
            domProps: { innerHTML: _vm._s(_vm.das.head) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.das.trunk
        ? _c("div", {
            attrs: { "aria-hidden": "true" },
            domProps: { innerHTML: _vm._s(_vm.das.trunk) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.das.member
        ? _c("div", {
            attrs: { "aria-hidden": "true" },
            domProps: { innerHTML: _vm._s(_vm.das.member) },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }